<template>
  <div
    v-if="segundos > 0 && !loading"
    style="
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
      margin-top: 20px;
    "
  >
    <h4
      style="
        display: flex;
        flex-direction: column;
        gap: 10px;
        text-align: center;
        align-items: center;
        justify-content: center;
      "
    >
      A transação expira em:
      <h1 style="font-weight: bold; font-size: 4rem">{{ timer }}</h1>
    </h4>
    <h1>
      Valor:
      <b>R$ {{ String(pagamentoPix.valor.toFixed(2)).replaceAll(".", ",") }}</b>
    </h1>
    <div id="qrcode" ref="qrcode"></div>
    <input
      type="text"
      v-model="pagamentoPix.payload"
      class="form-control"
      onfocus="event.target.select()"
      readonly
      style="accent-color: #000; margin-right: 8px; max-width: 400px"
    />
    <button
      @click="copiarPayload()"
      style="align-items: center; background-color: #006400"
      class="btn btn-dark"
    >
      Copiar Chave Pix
    </button>
    <span style="text-align: center; max-width: 400px"
      >A confirmação do pagamento é feita automaticamente. Não é necessário
      atualizar a página!</span
    >
  </div>
  <div
    v-else-if="!loading"
    style="
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
      margin-top: 20px;
    "
  >
    <h1
      style="
        display: flex;
        flex-direction: column;
        gap: 10px;
        text-align: center;
        align-items: center;
        justify-content: center;
      "
    >
      Transação expirada!
    </h1>
    <span style="text-align: center; max-width: 400px"
      >O QrCode do pagamento expirou, volte ao cardápio e faça seu pedido
      novamente!</span
    >
    <button
      @click="voltarCardapio()"
      style="align-items: center; background-color: #dc3545"
      class="btn btn-dark"
    >
      Voltar ao Cardápio
    </button>
  </div>
  <div v-else style="display: flex; justify-content: center;">
    <div
      class="spinner-border"
      style="width: 6rem; height: 6rem;"
      role="status"
    >
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import QRCodeStyling, {
  DrawType,
  TypeNumber,
  Mode,
  ErrorCorrectionLevel,
  DotType,
  CornerSquareType,
  CornerDotType,
  Extension,
} from "qr-code-styling";
import Swal from "sweetalert2";
import api from "../services/api";
import Inis from "../services/inis";

export default {
  name: "PagamentoPix",
  data() {
    return {
      loading: true,
      plataformaPix: "",
      intervalPix: null,
      interval: null,
      segundos: 0,
      timer: "",
      optionsQrCode: {
        type: "canvas",
        shape: "square",
        width: 200,
        height: 200,
        data: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      logado: "retornaLogado",
      pagamentoPix: "getPagamentoPix",
    }),
  },
  methods: {
    async listarInis() {
      await Inis.listarInisCd("PLATAFORMA_PIX").then((resposta) => {
        this.plataformaPix = resposta.data[0].vl;
      });
    },
    async createQrCode() {
      this.loading = false;
      await this.$nextTick();
      this.optionsQrCode.data = this.pagamentoPix.payload;
      new QRCodeStyling(this.optionsQrCode).append(this.$refs["qrcode"]);
    },
    formatarSegundos(segundosTotais) {
      if (segundosTotais < 60) {
        return `${segundosTotais}`;
      }

      const minutos = Math.floor(segundosTotais / 60);
      const segundos = segundosTotais % 60;

      return `${minutos}:${segundos.toString().padStart(2, "0")}`;
    },
    async iniciarTimer() {
      if (this.interval) return;

      const agora = new Date(
        new Date().toLocaleString("en-US", { timeZone: "America/Sao_Paulo" })
      );
      const dataExpiracao = new Date(
        new Date(this.pagamentoPix.date).toLocaleString("en-US", {
          timeZone: "America/Sao_Paulo",
        })
      );

      this.segundos = Math.floor(
        (dataExpiracao.getTime() - agora.getTime()) / 1000
      );

      this.interval = setInterval(() => {
        if (this.segundos > 0) {
          this.segundos--;
          this.timer = this.formatarSegundos(this.segundos);
        } else {
          clearInterval(this.interval);
          this.interval = null;
        }
      }, 1000);
    },
    async checarPix() {
      this.intervalPix = setInterval(async () => {
        if (this.segundos < 0) {
          clearInterval(this.intervalPix);
          this.intervalPix = null;
          this.$store.commit("setPagamentoPix", null);
          return;
        }
        try {
          if (this.plataformaPix === "asaas") {
            await api.post(
              "/pix/asaas/checar",
              {
                id: this.pagamentoPix.id,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem(
                    "token" + localStorage.getItem("contrato")
                  )}`,
                },
              }
            );
          } else if (this.plataformaPix === "paggpix") {
            await api.post(
              "/pix/paggpix/checar",
              {
                id: this.pagamentoPix.id,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem(
                    "token" + localStorage.getItem("contrato")
                  )}`,
                },
              }
            );
          }

          clearInterval(this.intervalPix);
          this.intervalPix = null;
          Swal.fire({
            icon: "success",
            title: "Pedido realizado com sucesso!",
            text: "Seu pagamento foi recebido e seu pedido foi aprovado.",
          });
          var win = window.open(this.pagamentoPix.linkWpp, "_blank");
          if (win == null || win == undefined) {
            window.location.assign(this.pagamentoPix.linkWpp);
          }
          this.$store.commit("setPagamentoPix", null);
          this.$router.push("/");
        } catch {}
      }, 5000);
    },
    copiarPayload() {
      navigator.clipboard.writeText(this.pagamentoPix.payload);
      Swal.fire({
        icon: "success",
        title: "Chave pix copiada!",
      });
    },
    voltarCardapio() {
      this.$router.push("/");
    },
  },
  created() {
    if (this.logado == false) {
      this.$router.push("/login");
    }

    if (!this.pagamentoPix) {
      this.$router.push("/");
    }
  },
  destroyed() {
    clearInterval(this.interval);
    clearInterval(this.intervalPix);
  },
  async mounted() {
    await this.listarInis(),
      await this.iniciarTimer(),
      this.createQrCode(),
      this.checarPix();
  },
};
</script>
